import { Component, Input, OnInit, OnDestroy, HostBinding, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import swal from 'sweetalert2';
import { BillingService } from '../../../services/billing.service';
import { getParamFromAncestorRoute, getQueryParamFromAncestorRoute } from '../../../utilities/route.utilities';


@Component({
    selector: 'billing-payments-by-type-grid-item',
    templateUrl: './billing-payments-by-type-grid-item.component.html',
})
export class BillingPaymentsByTypeGridItemComponent implements AfterViewInit, OnDestroy {

    subscriptions: any[] = [];
    timePeriod: number = 1;
    clientId: number;
    siteId: number;
    payemntByType: any[] = [];
    hasData: boolean = false;
    hasLoading: boolean = true;

    constructor(
        private billingService: BillingService,
        private route: ActivatedRoute,
        private router: Router) {
    }

    ngAfterViewInit(): void {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    onInitialise() {
        this.clientId = getParamFromAncestorRoute(this.route, 'clientId');
        this.timePeriod = getQueryParamFromAncestorRoute(this.route, 'timePeriod');
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    onInfoClick() {
        swal({
            title: 'Payments by type',
            html: '<p style="text-align: left;">This chart is showing you all payments made by consumers in your Billing portfolio.</p>\
              <p style="text-align: left;">Shown by total value of all payments in each Month & Year as per the number of full months in the page filter and current month to date, by payment method type.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
